export class StorageService {
    set(k, v) {
        localStorage.setItem(k, JSON.stringify(v));
    }
    get(k) {
        try {
            return JSON.parse(localStorage.getItem(k));
        }
        catch (_e) {
            return null;
        }
    }
    del(k) {
        localStorage.removeItem(k);
    }
}
